// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__dQAh5","image__upload":"styles_image__upload__2fJ2P","image__input":"styles_image__input__2uicF","image":"styles_image__2FM35"};